import { useTranslation } from "@/i18n/client";
import color from "@/styles/color";
import { Box, Typography } from "@mui/material";

import SorryImg from "@/assets/image/sorry.webp";
import { FC } from "react";

type EmptyProps = {
  title?: string;
  chlid: JSX.Element
};

const Empty: FC<EmptyProps> = ({ title, chlid }) => {
  const { t } = useTranslation();
  
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: { xs: "20px", sm: "24px", lg: "34px" },
          paddingBottom: { xs: "16px", sm: "24px", lg: "34px" },
          gap: 3,
        }}
      >
        <Box
          component="img"
          sx={{
            width: { xs: "150px", sm: "200px", xl: "300px" },
            height: { xs: "150px", sm: "200px", xl: "300px" },
          }}
          alt="Empty Image"
          src={SorryImg.src}
        />
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: { xs: "18px", xl: "24px" },
            lineHeight: { xs: "27.2px", xl: "36.26px" },
            color: color.black,
            whiteSpace: "pre-wrap",
          }}
        >
          {title || t("common.empty.title")}
        </Typography>
        {chlid}
      </Box>
    </Box>
  );
};

export default Empty;
